import { lazy } from "react";
import { RouteConfig } from "../../../../../types/RouteConfig";
import { errorMembershipRoute } from "../../../../error/PageMembershipStatusError/route";

export const healthAndSafetyRiskAssessmentRoute: RouteConfig<'with-page'> = {
    name: 'Health & Safety Risk Assessment',
    page: lazy(() => import('.')),
    context: 'member',
    path: '/documents/company/health-and-safety-risk-assessment',
    flags: ['member-route', 'no-menu-item'],
    permissions: ['companyDocuments'],
    permissionsRedirect: errorMembershipRoute,
}